/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import {IStreamSubscriber} from './IStreamSubscriber';
import EdgeAuthParser from '../../edgeAuth/EdgeAuthParser';
import RealTimeStreamSubscriber from './RealTimeStreamSubscriber';
import {ILogger} from '../../logger/LoggerInterface';
import LoggerFactory from '../../logger/LoggerFactory';
import ChannelState from '../channels/ChannelState';
import ChannelContext from '../context/ChannelContext';
import PeerConnectionContext from '../context/PeerConnectionContext';
import StreamTransformContext from '../context/StreamTransformContext';
import FrameTimingInformationContext from '../context/FrameTimingInformationContext';

export default class RealTimeStreamSubscriberFactory {
  private static _logger: ILogger = LoggerFactory.getLogger('Streaming');

  static create(token: string, channelContext: ChannelContext, peerConnectionContext: PeerConnectionContext, streamTransformContext: StreamTransformContext, frameTimingInformationContext: FrameTimingInformationContext, handleStreamFailure: () => Promise<void>): IStreamSubscriber | undefined {
    const tokenCapabilities = EdgeAuthParser.parseToken(token).capabilities;

    if (tokenCapabilities.includes('on-demand')) {
      this._logger.error('This build does not support On-Demand Stream playback.');
      channelContext.state.value = ChannelState.UnsupportedFeature;

      return;
    }

    if (tokenCapabilities.includes('streaming')) {
      this._logger.error('This build does not support Live Stream playback.');
      channelContext.state.value = ChannelState.UnsupportedFeature;

      return;
    }

    return new RealTimeStreamSubscriber(channelContext, peerConnectionContext, streamTransformContext, frameTimingInformationContext, handleStreamFailure);
  }

  constructor() {
    throw new Error('RealTimeStreamSubscriberFactory is a static class that may not be instantiated');
  }
}